module.exports = Em.Mixin.create({
    queryParams: {
        code: 'code',
        state: 'state'
    },

    code: null,
    state: null
})
